import { render, staticRenderFns } from "./SelectButton.vue?vue&type=template&id=1c6fa907&"
import script from "./SelectButton.vue?vue&type=script&lang=js&"
export * from "./SelectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports